import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import {useId} from "react";

import {OptionItem, SingleSelect} from "@khanacademy/wonder-blocks-dropdown";
import {isTruthy} from "@khanacademy/wonder-stuff-core";
import {useQuery} from "@khan/data-gql";

import {COACHED_CLASSROOMS_QUERY} from "../graphql/coached-classrooms-query.ts";

import {RequestedInputLabel} from "./requested-input-label.tsx";

interface Props {
    label: string;
    value: string;
    onChange: (newValue: string) => void;
    description?: string;
    required?: boolean;
    disabled?: boolean;
    error?: string | null;
}

export const RequestedInputClassroomSelect = ({
    label,
    value,
    onChange,
    required,
    disabled,
    description,
    error,
}: Props): React.ReactElement => {
    const id = useId();
    const [result] = useQuery(COACHED_CLASSROOMS_QUERY);

    const classrooms =
        result.status === "success"
            ? (result.data.user?.coachedClassrooms?.filter(isTruthy) ?? [])
            : [];

    return (
        <RequestedInputLabel
            id={id}
            label={label}
            description={description}
            required={required}
            error={error}
        >
            <SingleSelect
                id={id}
                selectedValue={value}
                onChange={onChange}
                placeholder={t`Select a classroom...`}
                disabled={disabled}
                aria-required={required}
                aria-details={description}
                style={styles.select}
            >
                {classrooms.map((c) => (
                    <OptionItem
                        value={c.descriptor}
                        label={c.name}
                        key={c.descriptor}
                    />
                ))}
            </SingleSelect>
        </RequestedInputLabel>
    );
};

const styles = StyleSheet.create({
    select: {
        width: "100%",
    },
});
